import * as React from 'react';
export const IcDrama = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.71 8.29A1 1 0 0020 8H9a1 1 0 00-1 1v6c0 4.65 5.91 6.85 6.16 6.94a1 1 0 00.68 0C15.09 21.85 21 19.65 21 15V9a1 1 0 00-.29-.71zm-9.92 3a1 1 0 011.27-.12.94.94 0 01.36.45 1 1 0 01.06.58 1 1 0 01-.78.78 1 1 0 01-.58-.06.94.94 0 01-.45-.36 1 1 0 01.12-1.27zm7.46 5a4.93 4.93 0 01-1.69 1.27 4.94 4.94 0 01-4.12 0 4.93 4.93 0 01-1.69-1.27.999.999 0 01-.26-.34.9.9 0 01-.1-.42c0-.145.03-.288.09-.42a1 1 0 01.26-.35 1.07 1.07 0 01.38-.2.901.901 0 01.43 0 .83.83 0 01.4.16 1 1 0 01.3.31 3 3 0 001 .75 2.94 2.94 0 002.46 0 3 3 0 001-.75 1 1 0 011.72.61 1 1 0 01-.18.68v-.03zm0-3.61a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.06-.58 1 1 0 01.74-.77 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27l.04-.01zM16 6V3a1 1 0 00-1-1H4a1 1 0 00-1 1v6a6.64 6.64 0 003 5.19V9a3 3 0 01.24-1.17 2.85 2.85 0 01.67-1 2.93 2.93 0 011-.65A3.1 3.1 0 019.08 6H16z'
      fill='currentColor'
    />
  </svg>
);
